import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);


const pengBang = [
    { path: "/index", name: "IndexPage", meta: { index: 0 }, component: () => import('../views/index') },
    { path: "/detail", name: "DetailPage", meta: { index: 1 }, component: () => import('../views/info.vue') },


];


export default new VueRouter({
    routes: [
        { path: "*", redirect: "/index" }, // 通配进入首页
        ...pengBang,
    ]
});